// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u012x7{margin-left:var(--ds-space-075,6px)}\n._1e0c1txw{display:flex}\n._2lx21sbv{flex-direction:row-reverse}\n._syaz1gjq{color:var(--ds-text-subtle,#44546f)}\n._30l316c2:hover{color:var(--ds-link-pressed,#05c)}", ""]);
// Exports
module.exports = exports;
